import { type VacancyStatus as VacancyStatusType } from '#imports'

export function vacancyStatusColor(status: VacancyStatusType) {
  switch (status) {
    case VacancyStatus.Published:
      return 'success'
    case VacancyStatus.Filled:
    case VacancyStatus.Expired:
    case VacancyStatus.Archived:
      return 'warning'
    case VacancyStatus.Deleted:
      return 'danger'
    case VacancyStatus.Draft:
      return 'info'
    default:
      return 'muted'
  }
}
